/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetExperimentExposureActivePathParams = NonNullable<
  operations['getExperimentExposureActive']['parameters']['path']
>;

export type GetExperimentExposureActiveQueryParams = NonNullable<
  operations['getExperimentExposureActive']['parameters']['query']
>;

export interface Input extends GetExperimentExposureActivePathParams {
  apiVersion?: string;
  query: GetExperimentExposureActiveQueryParams;
}

export async function getExperimentExposureActive(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/environments/{environmentKey}/usage/experiment-exposure-active',
    {
      params: { path, query },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
